import { IconButton } from '@patrianna/core-components'
import { openDialog } from '@patrianna/dialog-manager'
import { useMediaQuery } from '@patrianna/shared-hooks'
import { nextTick } from '@patrianna/shared-utils'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { InformationOutline } from '@patrianna-icons/material-icons'
import { useRouter } from 'next/navigation'
import { memo } from 'react'

import NumberAnimation from 'components/NumberAnimation'
import { IS_BRAND_PULSZ } from 'config/brands'
import ROUTES from 'config/routes.json'
import classes from 'containers/Menu/AccountInfo/styles.module.scss'
import { useAppSelector } from 'store/hooks'
import { getUserVipPointsLevelSelector } from 'store/modules/user/selectors'

import content from '../../../../prismic-translates/common.json'

const t = getTranslationFromJson([content])

const VipLevelAnimatedComponent = ({ hideMenuCallback }: { hideMenuCallback: () => void }) => {
  const isMobile = useMediaQuery('xs')
  const router = useRouter()
  const vipLevel = useAppSelector(getUserVipPointsLevelSelector)

  const handleClickIconButton = () => {
    nextTick().then(() => {
      if (IS_BRAND_PULSZ) {
        router.push(ROUTES.PULSZ_POINTS)
        if (isMobile) {
          hideMenuCallback()
        }

        return
      } else if (isMobile) {
        openDialog({ dialogName: 'VIP_REWARDS_DIALOG' })
      } else {
        router.push(ROUTES.VIP_REWARDS)
      }
    })
  }

  if (!vipLevel) {
    return null
  }

  return (
    <div className={classes.item}>
      <span className={classes.itemText}>
        {t('vip')}: {vipLevel?.name}{' '}
        <IconButton data-test='menu-vip-info-link' className={classes.link} onClick={handleClickIconButton}>
          <InformationOutline />
        </IconButton>
      </span>
      <span className={classes.itemText}>
        <NumberAnimation amount={vipLevel?.current} currency='vip' decimalSeparator='' thousandsSeparator='' />{' '}
        {t('vip_points')}
      </span>
    </div>
  )
}

export const VipLevelAnimated = memo(VipLevelAnimatedComponent)
